/*
 * @Author: ghy
 * @Date: 2023-07-17 12:51:36
 * @LastEditors: ghy
 * @LastEditTime: 2023-07-28 13:12:28
 * @Description: 
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./styles/common.css";
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import ElementUI from "element-ui";
import CusTitle from "@/components/CusTitle.vue";
import "element-ui/lib/theme-chalk/index.css";

import { parseTime,showKeyWord } from "@/utils";
Vue.config.productionTip = false
Vue.use(ElementUI, { zIndex: 1000 });
Vue.component("cus-title", CusTitle);
Vue.prototype.parseTime = parseTime
Vue.prototype.showKeyWord = showKeyWord
Vue.prototype.$EventBus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js